<header class="header-topnav mat-elevation-z2">
  <div class="container">
    <div class="topnav">
      <!-- App Logo -->
      <div class="topbar-branding">
        <img src="/assets/qtaclogo.png" alt="QTAC logo" class="app-logo">
      </div>

      @if (!layoutConf.isMobile) {
        <nav aria-label="Primary navigation">
        <ul class="menu">
          @for (item of menuItems; track item; let i = $index) {
            <li>
              @if (item.type !== 'separator') {
                <div routerLinkActive="open">
                  @if (item.type === 'link') {
                    <a matRipple routerLink="/{{item.state}}">
                      <mat-icon aria-hidden="true">{{item.icon}}</mat-icon>
                      {{item.name | translate}}
                    </a>
                  }
                  @if (item.type === 'dropDown') {
                    <div [class.dropdown-open]="isDropdownOpen('drop-' + i)">
                      <button
                        type="button"
                        class="toggle"
                        matRipple
                        (click)="toggleDropdown('drop-' + i)"
                        [attr.aria-expanded]="isDropdownOpen('drop-' + i)"
                        [attr.aria-controls]="'drop-menu-' + i"
                      >
                        <mat-icon aria-hidden="true">{{item.icon}}</mat-icon>
                        {{item.name | translate}}
                      </button>
                      <ul [id]="'drop-menu-' + i">
                        @for (itemLvL2 of item.sub; track itemLvL2; let j = $index) {
                          <li routerLinkActive="open">
                            @if (itemLvL2.type !== 'dropDown') {
                              <a matRipple routerLink="{{item.state ? '/'+item.state : ''}}/{{itemLvL2.state}}">
                                @if (itemLvL2.icon) {
                                  <mat-icon aria-hidden="true">{{itemLvL2.icon}}</mat-icon>
                                }
                                {{itemLvL2.name | translate}}
                              </a>
                            }
                            @if (itemLvL2.type === 'dropDown') {
                              <div [class.dropdown-open]="isDropdownOpen('drop-' + i + '-' + j)">
                                <button
                                  type="button"
                                  class="toggle"
                                  matRipple
                                  (click)="toggleDropdown('drop-' + i + '-' + j)"
                                  [attr.aria-expanded]="isDropdownOpen('drop-' + i + '-' + j)"
                                  [attr.aria-controls]="'drop-menu-' + i + '-' + j"
                                >
                                  @if (itemLvL2.icon) {
                                    <mat-icon aria-hidden="true">{{itemLvL2.icon}}</mat-icon>
                                  }
                                  {{itemLvL2.name | translate}}
                                </button>
                                <!-- Level 3 -->
                                <ul [id]="'drop-menu-' + i + '-' + j">
                                  @for (itemLvL3 of itemLvL2.sub; track itemLvL3) {
                                    <li routerLinkActive="open">
                                      <a matRipple routerLink="{{item.state ? '/'+item.state : ''}}{{itemLvL2.state ? '/'+itemLvL2.state : ''}}/{{itemLvL3.state}}">
                                        @if (itemLvL3.icon) {
                                          <mat-icon aria-hidden="true">{{itemLvL3.icon}}</mat-icon>
                                        }
                                        {{itemLvL3.name | translate}}
                                      </a>
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              }
            </li>
          }
        </ul>
        </nav>
      }
      <span class="flex-spacer"></span>
      <!-- End Navigation -->

      <!-- Language Switcher -->
      @if (!layoutConf.isMobile) {
        <mat-select
          placeholder=""
          id="langToggle"
          aria-label="Language"
          [style.width]="'auto'"
          name="currentLang"
          [(ngModel)]="currentLang"
          (selectionChange)="setLang()"
          class="topbar-button-right">
          @for (lang of availableLangs; track lang) {
            <mat-option
            [value]="lang.code" ngDefaultControl>{{ lang.name }}</mat-option>
          }
        </mat-select>
      }
      <!-- Theme Switcher -->
      <button
        mat-icon-button
        id="schemeToggle"
        aria-label="Color schemes"
        [style.overflow]="'visible'"
        matTooltip="Color Schemes"
        [matMenuTriggerFor]="themeMenu"
        class="topbar-button-right">
        <mat-icon>format_color_fill</mat-icon>
      </button>
      <mat-menu #themeMenu="matMenu">
        <mat-grid-list
          class="theme-list"
          cols="2"
          rowHeight="48px">
          @for (theme of themes; track theme) {
            <mat-grid-tile>
              <button
                type="button"
                mat-menu-item
                [attr.aria-label]="theme.name"
                [title]="theme.name"
                (click)="changeTheme(theme)"
              >
                <span [style.background]="theme.baseColor" class="q-theme-swatch" aria-hidden="true"></span>
                @if (theme.isActive) {
                  <mat-icon class="active-icon" aria-hidden="true">check</mat-icon>
                }
              </button>
            </mat-grid-tile>
          }
        </mat-grid-list>
      </mat-menu>
      <!-- Notification toggle button -->
      <button
        mat-icon-button
        aria-label="Open notifications"
        matTooltip="Notifications"
        (click)="toggleNotific()"
        [style.overflow]="'visible'"
        class="topbar-button-right">
        <mat-icon>notifications</mat-icon>
        <span class="notification-number mat-bg-warn">3</span>
      </button>
      <!-- Top left user menu -->
      <button mat-icon-button aria-label="Open account menu" [matMenuTriggerFor]="accountMenu" class="topbar-button-right mr-4">
        <mat-icon aria-hidden="true">account_circle</mat-icon>
      </button>
      <mat-menu #accountMenu="matMenu">
        <button mat-menu-item [routerLink]="['/profile/overview']">
          <mat-icon>account_box</mat-icon>
          <span>Profile</span>
        </button>
        <button mat-menu-item [routerLink]="['/profile/settings']">
          <mat-icon>settings</mat-icon>
          <span>Account Settings</span>
        </button>
        <button mat-menu-item>
          <mat-icon>notifications_off</mat-icon>
          <span>Disable alerts</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>
      <!-- Mobile screen menu toggle -->
      @if (layoutConf.isMobile) {
        <button
          mat-icon-button
          class="mr-4"
          aria-label="Toggle navigation menu"
          [attr.aria-expanded]="layoutConf.sidebarStyle !== 'closed'"
          (click)="toggleSidenav()"
          >
          <mat-icon>menu</mat-icon>
        </button>
      }

    </div>
  </div>
</header>